import React from 'react';

const AIChatbot = () => {
  return (
    <div className="pt-24">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-[#E5F0F3] to-white">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#1E2A4A] mb-6">
              AI-Powered Chatbot
            </h1>
            <p className="text-xl text-gray-600">
              Enhance patient communication with intelligent automated responses
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <h2 className="text-2xl font-bold text-[#1E2A4A] mb-4">Key Features</h2>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center text-orange-500">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Instant Responses</h3>
                    <p className="text-gray-600">Real-time answers to common patient questions</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center text-orange-500">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Appointment Management</h3>
                    <p className="text-gray-600">Seamless scheduling and rescheduling of appointments</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center text-orange-500">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Insurance Verification</h3>
                    <p className="text-gray-600">Automated insurance coverage checks and updates</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="bg-[#001233] text-white rounded-2xl p-8 shadow-xl">
              <h2 className="text-2xl font-bold mb-4">Benefits</h2>
              <ul className="space-y-4">
                <li className="flex items-center space-x-3">
                  <div className="text-3xl font-bold text-orange-500">85%</div>
                  <div className="text-gray-300">Faster response time</div>
                </li>
                <li className="flex items-center space-x-3">
                  <div className="text-3xl font-bold text-orange-500">95%</div>
                  <div className="text-gray-300">Query resolution rate</div>
                </li>
                <li className="flex items-center space-x-3">
                  <div className="text-3xl font-bold text-orange-500">24/7</div>
                  <div className="text-gray-300">Patient support availability</div>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <h2 className="text-2xl font-bold text-[#1E2A4A] mb-6">How It Works</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold">1</div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Patient Query</h3>
                    <p className="text-gray-600">Patient sends message through website or app</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold">2</div>
                  <div>
                    <h3 className="font-semibold text-gray-900">AI Processing</h3>
                    <p className="text-gray-600">Chatbot analyzes and understands the request</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-orange-500 text-white flex items-center justify-center font-bold">3</div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Smart Response</h3>
                    <p className="text-gray-600">AI provides accurate and helpful information</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-8 shadow-xl text-white">
              <h2 className="text-2xl font-bold mb-4">Ready to Get Started?</h2>
              <p className="mb-6">Enhance patient communication with AI chatbot</p>
              <button className="w-full bg-white text-orange-600 px-6 py-3 rounded-xl font-semibold hover:bg-gray-100 transition-colors">
                Schedule a Demo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIChatbot; 